// import

import {styled} from 'goober';
import type {ComponentProps} from 'react';

import {Link as Lx} from 'modules/Link';

// component

export function MoreLink(props: ComponentProps<typeof Link>) {
  const {children, ...rest} = props;

  return (
    <Link {...rest}>
      <span>{children}</span>
      <span className="arrow">→</span>
    </Link>
  );
}

// styles

const Link = styled(Lx)`
  display: inline-flex;
  flex-wrap: nowrap;
  justify-items: stretch;
  border-radius: 0.25rem;
  text-transform: uppercase;
  transition: background 250ms linear;
  font-size: 1rem;
  font-weight: 400;
  height: 2rem;
  line-height: 2rem;
  letter-spacing: normal;
  padding: 0 1rem;
  background-image:
    linear-gradient(
      45deg,
      var(--orange) 0%,
      var(--orange) 5%,
      var(--red) 95%,
      var(--red) 100%
    );
  background-position: 100% center;
  background-size: 500% 100%;
  color: var(--white);

  .arrow {
    margin-left: 0.25rem;
    transition: transform 250ms linear;
    transform: translateX(0);
    font-size: 1rem;
  }

  &:hover {
    background-position: 0% center;

    & .arrow {
      transform: translateX(0.25rem);
    }
  }
`;
